import React from "react";

const NavbarLink = ({ darkBg, title, url }) => {
  const active = window.location.pathname === url;
  return (
    <a
      href={url}
      className={` text-sm
      ${active && "font-semibold underline"}
      hover:text-gray-${darkBg ? "200" : "800"}
      ${darkBg && "text-white"}`}
    >
      {title}
    </a>
  );
};

export default NavbarLink;
